export default "__VITE_ASSET__7f5a7a81__"